<template>
  <vs-row vs-justify="center" id="services-box">
    <vs-col
      type="flex"
      vs-justify="center"
      vs-align="center"
      vs-lg="12"
      vs-xs="12"
    >
      <vs-card>
        <vs-table
          @search="handleSearch"
          @sort="handleSort"
          v-model="selected"
          :total="totalItems"
          max-items="10"
          search
          :data="services"
        >
          <div slot="header">
            <vs-button
              id="add-service-form"
              icon="add"
              color="primary"
              @click="activePrompt = true"
              >{{ $t("Service.AddServiceButton") }}</vs-button
            >
            <!-- <vs-button
              id="add-service-form"
              icon="update"
              color="warning"
              class="ml-4"
              @click="activePromptParams = true"
              >{{ "parametrage" }}</vs-button
            > -->
            <!---Add Contact --->
            <vs-prompt
              color="primary"
              @accept="acceptAlert"
              @close="close"
              @cancel="close"
              :active.sync="activePrompt"
              :title="$t('Service.AddServicePrompt.Title')"
              :accept-text="$t('Service.AddServicePrompt.SubmitButton')"
              :cancel-text="$t('Service.AddServicePrompt.CancelButton')"
            >
              <div v-bar class="vs-scrollable">
                <div>
                  <div class="con-exemple-prompt px-4 py-3">
                    <vs-select
                      :danger="errors.service_id"
                      :danger-text="
                        $t('Errors.Required', {
                          field: $t('Service.AddServicePrompt.ServiceLabel'),
                        })
                      "
                      class="w-100 mb-2 mt-2"
                      size="large"
                      autocomplete
                      :placeholder="
                        $t('Service.AddServicePrompt.ServicePlaceholder')
                      "
                      :label="$t('Service.AddServicePrompt.ServiceLabel')"
                      v-model="promptData.service_id"
                    >
                      <vs-select-item
                        :key="index"
                        :value="item.id"
                        :text="item.title"
                        v-for="(item, index) in industryServices"
                      />
                    </vs-select>

                    <vs-input
                      :danger="errors.duration"
                      :danger-text="
                        $t('Errors.InvalidPolite', {
                          field: $t('Service.AddServicePrompt.Duration'),
                        })
                      "
                      :label="$t('Service.AddServicePrompt.Duration')"
                      v-model="promptData.duration"
                      class="w-100 mb-4"
                    />
                    <vs-input
                      :danger="errors.duration_in_seconds"
                      :danger-text="
                        $t('Errors.InvalidPolite', {
                          field: $t('Service.AddServicePrompt.DurationSeconds'),
                        })
                      "
                      :label="$t('Service.AddServicePrompt.DurationSeconds')"
                      v-model="promptData.duration_in_seconds"
                      class="w-100 mb-4"
                    />
                    <vs-input
                      :danger="errors.price"
                      :danger-text="
                        $t('Errors.InvalidPolite', {
                          field: $t('Service.AddServicePrompt.Price'),
                        })
                      "
                      :label="$t('Service.AddServicePrompt.Price')"
                      v-model="promptData.price"
                      class="w-100 mb-4"
                    />
                    <vs-checkbox
                      class="mb-2"
                      style="float: left"
                      v-model="showParentServices"
                    >
                      {{ $t("Service.AddServicePrompt.SubService") }}
                    </vs-checkbox>
                    <div v-if="showParentServices">
                      <vs-select
                        :danger="errors.parent_service_id"
                        :danger-text="
                          $t('Errors.Required', {
                            field: $t('Service.AddServicePrompt.ServiceLabel'),
                          })
                        "
                        class="w-100 mb-2 mt-2"
                        size="large"
                        autocomplete
                        :placeholder="
                          $t('Service.AddServicePrompt.ServicePlaceholder')
                        "
                        :label="$t('Service.Table.ParentServiceId')"
                        v-model="promptData.parent_service_id"
                      >
                        <vs-select-item
                          :key="index"
                          :value="item.service_id"
                          :text="item.title"
                          v-for="(item, index) in servicesParent"
                        />
                      </vs-select>
                    </div>
                  </div>
                </div>
              </div>
            </vs-prompt>

            <vs-prompt
              color="warning"
              @accept="updateService"
              @close="close"
              @cancel="close"
              :active.sync="activeUpdatePrompt"
              :title="$t('Service.EditServicePrompt.Title')"
              :accept-text="$t('Service.EditServicePrompt.SubmitButton')"
              :cancel-text="$t('Service.EditServicePrompt.CancelButton')"
            >
              <div v-bar class="vs-scrollable">
                <div>
                  <div class="con-exemple-prompt px-4 py-3">
                    <h4 class="w-100 mb-4">
                      {{ $t("Service.AddServicePrompt.ServiceLabel") }}:
                      <b>{{ selected.title }}</b>
                    </h4>
                    <!-- <vs-select
            :label="$t('Booking.DepartmentFilterPlaceholder')"
            v-if="departments.length>0"
            v-model="selectedDepartment"
            :placeholder="$t('Booking.DepartmentFilterPlaceholder')"
            class="w-100"
            @change="getServiceTimeByDepartment"
          >
            <vs-select-item
              :key="index"
              :value="item.id"
              :text="item.name"
              v-for="(item,index) in departments"
            />
          </vs-select> -->
                    <vs-input
                      :danger="errors.selected.duration"
                      :danger-text="
                        $t('Errors.InvalidPolite', {
                          field: $t('Service.AddServicePrompt.Duration'),
                        })
                      "
                      :label="$t('Service.AddServicePrompt.Duration')"
                      v-model="selectedMinutes"
                      class="w-100 mb-4"
                    />
                    <vs-input
                      :danger="errors.selected.duration_in_seconds"
                      :danger-text="
                        $t('Errors.InvalidPolite', {
                          field: $t('Service.AddServicePrompt.DurationSeconds'),
                        })
                      "
                      :label="$t('Service.AddServicePrompt.DurationSeconds')"
                      v-model="selectedSeconds"
                      class="w-100 mb-4"
                    />
                    <vs-input
                      :danger="errors.selected.price"
                      :danger-text="
                        $t('Errors.InvalidPolite', {
                          field: $t('Service.AddServicePrompt.Price'),
                        })
                      "
                      :label="$t('Service.AddServicePrompt.Price')"
                      v-model="selected.price"
                      class="w-100 mb-4"
                    />
                    <vs-checkbox
                      class="mb-2"
                      style="float: left"
                      v-model="showParentServices"
                      v-if="selected.parent_service_id != null ? false : true"
                    >
                      {{ $t("Service.AddServicePrompt.SubService") }}
                    </vs-checkbox>
                    <div
                      v-if="
                        selected.parent_service_id != null
                          ? true
                          : showParentServices
                      "
                    >
                    <h6 class="ml-1">{{$t('Service.Table.ParentServiceId')}}</h6>
                      <vs-row>
                        <vs-col vs-w="10">
                          
                          <vs-select
                            :danger="errors.parent_service_id"
                            :danger-text="
                              $t('Errors.Required', {
                                field: $t(
                                  'Service.AddServicePrompt.ServiceLabel'
                                ),
                              })
                            "
                            class="w-100 mb-2 mt-2"
                            size="large"
                            autocomplete
                            :placeholder="
                              $t('Service.AddServicePrompt.ServicePlaceholder')
                            "
                          
                            v-model="selected.parent_service_id"
                          >
                            <vs-select-item
                              :key="index"
                              :value="item.service_id"
                              :text="item.title"
                              v-for="(item, index) in servicesParent"
                            />
                          </vs-select>
                        </vs-col>
                        <vs-col vs-w="2">
                          <vs-button
                            class="w-100 mt-1"
                            color="danger"
                            type="filled"
                            @click="selected.parent_service_id = null"
                          >
                            <i class="mdi mdi-delete"></i>
                          </vs-button>
                        </vs-col>
                      </vs-row>
                    </div>
                  </div>
                </div>
              </div>
              <v-tour name="ServicesB" :steps="steps">
                <template slot-scope="tour">
                  <transition name="fade">
                    <v-step
                      v-if="tour.currentStep === index"
                      v-for="(step, index) of tour.steps"
                      :key="index"
                      :step="step"
                      :previous-step="tour.previousStep"
                      :next-step="tour.nextStep"
                      :stop="tour.stop"
                      :is-first="tour.isFirst"
                      :is-last="tour.isLast"
                      :labels="tour.labels"
                    >
                      <template v-if="tour.currentStep === 0">
                        <div slot="actions" class="v-step__buttons">
                          <button @click="promptShowNew" class="v-step__button">
                            Next
                          </button>
                        </div>
                      </template>
                      <!--<template v-if="tour.currentStep === 1">
                          <div slot="actions" @click="promptShow">
                              <button @click="tour.nextStep" class="btn btn-primary btn-lg outline">Next step</button>
                          </div>
                      </template>-->
                    </v-step>
                  </transition>
                </template>
              </v-tour>
            </vs-prompt>
          </div>
          <template slot="thead">
            <vs-th sort-key="service">{{ $t("Service.Table.Service") }}</vs-th>
            <vs-th sort-key="duration">{{
              $t("Service.Table.EstimatedDuration")
            }}</vs-th>
            <vs-th sort-key="price">{{ $t("Service.Table.Price") }}</vs-th>
            <vs-th sort-key="Parent_service_id">{{
              $t("Service.Table.ParentServiceId")
            }}</vs-th>
            <vs-th sort-key="created_at">{{
              $t("Service.Table.CreatedAt")
            }}</vs-th>
            <vs-th>{{ $t("Service.Table.Options") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].title">
                <div class="d-flex align-items-center">
                  <h5 class="mb-0 font-12">{{ data[indextr].title }}</h5>
                </div>
              </vs-td>

              <vs-td :data="data[indextr].duration">
                <div class="d-flex align-items-center">
                  <i class="mdi mdi-clock mr-2 display-8"></i>
                  <span
                    class=""
                    v-if="
                      data[indextr].duration_in_seconds === null ||
                        data[indextr].duration_in_seconds === 0
                    "
                    >{{ data[indextr].duration }} {{ $t("Shared.Min") }}</span
                  >
                  <span
                    class=""
                    v-else-if="data[indextr].duration_in_seconds / 60 >= 1"
                    >{{ Math.floor(data[indextr].duration_in_seconds / 60) }}
                    {{ $t("Shared.Min") }}</span
                  >

                  &nbsp;
                  <span v-if="data[indextr].duration_in_seconds" class=""
                    >{{ data[indextr].duration_in_seconds % 60 }}
                    {{ $t("Shared.Sec") }}</span
                  >
                </div>
              </vs-td>

              <vs-td :data="data[indextr].price">
                <div class="d-flex align-items-center">
                  <i class="mdi mdi-cash mr-2 display-8"></i>
                  <span class="">{{ data[indextr].price }}</span>
                </div>
              </vs-td>

              <vs-td :data="data[indextr].parent">
                <div>
                  <p
                    class="mb-1 font-12 badge badge-light"
                    style="
                      box-shadow: 0px 0px 8px 1px #aaa;
                      border-radius: 5px;
                      margin-right: 5px;
                      display: block;
                    "
                    v-if="
                      data[indextr].parent_service_id && data[indextr].parent
                    "
                  >
                    {{ data[indextr].parent["title"] }}
                  </p>

                  <p
                    class="mb-1 font-12 badge badge-light"
                    style="
                      box-shadow: 0px 0px 8px 1px #aaa;
                      border-radius: 5px;
                      margin-right: 5px;
                      display: block;
                    "
                    v-else
                  >
                    {{ $t("Service.Table.NoParentService") }}
                  </p>
                </div>
              </vs-td>

              <vs-td :data="data[indextr].created_at">
                <div class="d-flex align-items-center">
                  <i class="mdi mdi-calendar-text mr-2 display-8"></i>
                  {{ formatDate(data[indextr].created_at) }}
                </div>
              </vs-td>

              <vs-td>
                <div class="btn-alignment">
                  <vs-button
                    id="edit-service-button"
                    radius
                    color="warning"
                    type="border"
                    icon="edit"
                    @click="
                      activeUpdatePrompt = true;
                      checkTime(
                        data[indextr].duration,
                        data[indextr].duration_in_seconds
                      );
                    "
                  ></vs-button>
                  <vs-button
                    radius
                    color="danger"
                    type="border"
                    icon="delete"
                    @click="deleteService(data[indextr])"
                  ></vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <!--V-Tour start-->
        <v-tour name="ServicesA" :steps="steps">
          <template slot-scope="tour">
            <transition name="fade">
              <v-step
                v-if="tour.currentStep === index"
                v-for="(step, index) of tour.steps"
                :key="index"
                :step="step"
                :previous-step="tour.previousStep"
                :next-step="tour.nextStep"
                :stop="tour.stop"
                :is-first="tour.isFirst"
                :is-last="tour.isLast"
                :labels="tour.labels"
              >
                <template v-if="tour.currentStep === 0">
                  <div slot="actions" class="v-step__buttons">
                    <button @click="promptShow" class="v-step__button">
                      Next
                    </button>
                  </div>
                </template>
                <template v-if="tour.currentStep === 1">
                  <div slot="actions" class="v-step__buttons">
                    <button @click="tour.previousStep" class="v-step__button">
                      Previous
                    </button>
                    <button @click="goToNextPage" class="v-step__button">
                      Next
                    </button>
                  </div>
                </template>
              </v-step>
            </transition>
          </template>
        </v-tour>
        <vs-pagination
          :total="totalPages"
          @change="handleChangePage"
          v-model="currentPage"
        ></vs-pagination>
      </vs-card>
    </vs-col>
    <!---settings popup --->
    <vs-prompt
      color="primary"
      @accept="acceptAlert"
      @close="close"
      @cancel="close"
      :active.sync="activePromptParams"
      :title="$t('Service.AddServicePrompt.Title')"
      :accept-text="$t('Service.AddServicePrompt.SubmitButton')"
      :cancel-text="$t('Service.AddServicePrompt.CancelButton')"
    >
      <div v-bar class="vs-scrollable">
        <div>
          <div class="con-exemple-prompt px-4 py-3">
            <vs-checkbox
              class="mb-2"
              style="float: left"
              v-model="settingsEnabled"
            >
              {{ $t("Service.AddServicePrompt.SubService") }}
            </vs-checkbox>
            <div v-if="settingsEnabled">
              <vs-input
                :danger="errors.duration"
                :danger-text="
                  $t('Errors.InvalidPolite', {
                    field: $t('Service.AddServicePrompt.Duration'),
                  })
                "
                :label="$t('Service.SettingsPrompt.HistoryRange')"
                v-model="historyRange"
                class="w-100 mb-4"
              />
              <vs-input
                :danger="errors.duration_in_seconds"
                :danger-text="
                  $t('Errors.InvalidPolite', {
                    field: $t('Service.AddServicePrompt.DurationSeconds'),
                  })
                "
                :label="$t('Service.SettingsPrompt.MinimumCount')"
                v-model="minimumCount"
                class="w-100 mb-4"
              />
            </div>
          </div>
        </div>
      </div>
    </vs-prompt>
  </vs-row>
</template>

<script>
import {
  privateServiceService,
  helpersService,
  departmentService,
} from "../../_services";
// moment
import router from "../../_helpers/router";

export default {
  name: "Services",
  data: () => ({
    historyRange: 60,
    minimumCount: 100,
    showParentServices: false,
    settingsEnabled: false,
    departments: [],
    title: "Services",
    activePrompt: false,
    activePromptParams: false,
    activeUpdatePrompt: false,
    services: [],
    servicesParent: [],
    industryServices: [],
    selectedDepartment: -1,
    promptData: {
      service_id: 0,
      duration: "",
      duration_in_seconds: null,
      price: "",
      parent_service_id: null,
      parent: null,
    },
    errors: {
      service_id: false,
      duration: false,
      duration_in_seconds: false,
      price: false,
      parent_service_id: false,
      selected: {
        duration: false,
        duration_in_seconds: false,
        price: false,
        parent_service_id: false,
        parent: false,
      },
    },
    selected: {},
    selectedSeconds: null,
    selectedMinutes: null,
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
    maxItems: 0,
    steps: [
      {
        target: "#add-service-form", // We're using document.querySelector() under the hood
        params: {
          placement: "right", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        },
      },
      {
        target: "#edit-service-button",
        params: {
          placement: "auto", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        },
      },
    ],
  }),
  methods: {
    checkTime(minutes, seconds) {
      if (seconds === null || seconds === 0) {
        this.selectedMinutes = minutes;
        this.selectedSeconds = seconds;
        return 0;
      } else {
        this.selectedSeconds = seconds % 60;
      }
      if (seconds / 60 >= 1) {
        this.selectedMinutes = Math.floor(seconds / 60);
      }
    },
    test() {
      this.activeUpdatePrompt = true;
      console.log(this.selected.id);
    },
    getServiceTimeByDepartment() {
      this.showLoading();
      privateServiceService
        .getDurationByDepartment(
          this.selected.service_id,
          this.selectedDepartment
        )
        .then((data) => {
          console.log(data);
          this.selected.duration = data.servicesDuration;
          this.selected.price = data.price;
          this.selected.parent_service_id = data.parent_service_id;
          console.log(this.selected);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text,
      });
    },
    validateFields() {
      this.errors.service_id = this.promptData.service_id
        ? isNaN(this.promptData.service_id)
          ? true
          : false
        : true;
      this.errors.duration = this.promptData.duration ? false : true;
      if (this.showParentServices === true) {
        this.errors.parent_service_id = this.promptData.parent_service_id
          ? false
          : true;
      } else {
        this.errors.parent_service_id = false;
      }
      if (this.promptData.duration_in_seconds != null) {
        if (
          !(
            1 <= this.promptData.duration_in_seconds &&
            this.promptData.duration_in_seconds <= 59
          )
        ) {
          this.errors.duration_in_seconds = true;
        } else this.errors.duration_in_seconds = false;
      }

      let {
        service_id,
        duration,
        parent_service_id,
        duration_in_seconds,
      } = this.errors;
      return !(
        service_id ||
        duration ||
        parent_service_id ||
        duration_in_seconds
      );
    },
    validateUpdatedFields() {
      this.errors.selected.duration = this.selected.duration
        ? isNaN(this.selected.duration)
          ? true
          : false
        : true;
      if (this.showParentServices === true) {
        this.errors.selected.parent_service_id = this.selected.parent_service_id
          ? false
          : true;
      } else {
        this.errors.selected.parent_service_id = false;
      }
      if (this.selectedSeconds != null && this.selectedSeconds != 0) {
        if (!(1 <= this.selectedSeconds && this.selectedSeconds <= 59)) {
          this.errors.selected.duration_in_seconds = true;
        } else this.errors.selected.duration_in_seconds = false;
      }

      let {
        duration,
        parent_service_id,
        duration_in_seconds,
      } = this.errors.selected;
      return !(duration || parent_service_id, duration_in_seconds);
    },
    showLoading() {
      this.$vs.loading({
        container: "#services-box",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#services-box > .con-vs-loading");
    },
    handleSelected() {
      /* eslint-disable */
      console.log(this.selected);
    },
    acceptAlert() {
      let res = this.validateFields();

      // get the title from id
      if (this.promptData.parent_service_id) {
        this.promptData.parent = this.servicesParent.find(
          (o) => o.service_id === this.promptData.parent_service_id
        ).title;
      }

      if (!res) {
        this.activePrompt = true;
        return false;
      }

      // convert seconds
      this.promptData.duration_in_seconds =
        parseInt(this.promptData.duration_in_seconds) +
        parseInt(this.promptData.duration) * 60;

      this.showLoading();
      privateServiceService
        .create(this.promptData)
        .then(
          function(data) {
            this.handleChangePage(1);
            this.activePrompt = false;
            helpersService.getAllServices().then(
              function(data) {
                this.industryServices = data.services.data;
              }.bind(this)
            );
            this.notify(
              this.$t("Toasts.Successful"),
              this.$t("Service.AddServicePrompt.ToastSuccess"),
              "success"
            );
          }.bind(this)
        )
        .catch(
          function() {
            this.notify(
              this.$t("Toasts.Error"),
              this.$t("Service.AddServicePrompt.ToastFail"),
              "danger"
            );
          }.bind(this)
        )
        .finally(
          function() {
            this.hideLoading();
            this.reset();
          }.bind(this)
        );
    },
    reset() {
      this.promptData = {
        service_id: 0,
        duration: "",
        duration_in_seconds: "",
        parent_service_id: null,
      };
      this.showParentServices = false;
    },
    close() {
      this.activePrompt = false;
      this.activeUpdatePrompt = false;
      this.activePromptParams = false;
      this.promptData = {
        service_id: 0,
        duration: "",
        duration_in_seconds: "",
        parent_service_id: null,
      };
      this.selected = {};
      this.showParentServices = false;
    },
    handleSearch(keyword) {
      if (keyword == "") {
        privateServiceService.getAll().then(
          function(data) {
            this.services = data.services.data;
            this.totalItems = data.services.total;
            this.totalPages = data.services.last_page;
            this.maxItems = data.services.per_page;
          }.bind(this)
        );
      }
      privateServiceService.filter(keyword).then(
        function(data) {
          this.services = data.services.data;
          this.totalItems = data.services.total;
        }.bind(this)
      );
    },
    handleChangePage(page) {
      this.showLoading();
      privateServiceService
        .getPage(page)
        .then(
          function(data) {
            this.services = data.services.data;
          }.bind(this)
        )
        .finally(() => {
          this.hideLoading();
        });
    },
    updateService() {
      let res = this.validateUpdatedFields();
      console.log("rest", res);
      if (!res) {
        this.activeUpdatePrompt = true;
        return false;
      }
      this.showLoading();
      if (this.selectedDepartment != -1) {
        let parent = null;

        // get the title from id
        if (this.parent_service_id != null) {
          parent = this.servicesParent.find(
            (o) => o.service_id === this.parent_service_id
          ).title;
        }
        this.selected = {
          id: this.selected.id,
          duration: this.selectedMinutes,
          duration_in_seconds:
            parseInt(this.selectedSeconds) +
            parseInt(this.selectedMinutes) * 60,
          price: this.selected.price,
          department_id: this.selectedDepartment,
          service_id: this.selected.service_id,
          parent_service_id: this.selected.parent_service_id,
          parent: parent,
        };
      } else {
        // get the title from id
        if (this.selected.parent_service_id) {
          this.selected.parent = this.servicesParent.find(
            (o) => o.service_id === this.selected.parent_service_id
          ).title;
        }
        this.selected.duration_in_seconds =
          parseInt(this.selectedSeconds) + parseInt(this.selectedMinutes) * 60;
        this.selected.duration = this.selectedMinutes;
      }
      privateServiceService
        .update(this.selected)
        .then(
          function(data) {
            this.handleChangePage(this.currentPage);
            this.activeEditPrompt = false;
            this.selectedDepartment = -1;
            this.notify(
              this.$t("Toasts.Successful"),
              this.$t("Service.EditServicePrompt.ToastSuccess"),
              "success"
            );
          }.bind(this)
        )
        .catch(
          function() {
            this.notify(
              this.$t("Toasts.Error"),
              this.$t("Service.EditServicePrompt.ToastFail"),
              "danger"
            );
          }.bind(this)
        )
        .finally(
          function() {
            this.hideLoading();
          }.bind(this)
        );
    },
    handleSort(key, active) {
      /* eslint-disable */
      console.log({ key, active });
    },
    formatDate: function(value) {
      let date = this.$moment(value).format("DD MMMM YYYY [at] HH:mm");
      return date;
    },
    deleteService(service) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("Service.DeleteServicePrompt.Title"),
        text: this.$t("Service.DeleteServicePrompt.Text", {
          name: service.title,
        }),
        acceptText: this.$t("Toasts.AcceptButton"),
        cancelText: this.$t("Toasts.CancelButton"),
        accept: function() {
          this.showLoading();
          privateServiceService
            .delete(service.id)
            .then(
              function(data) {
                this.handleChangePage(this.currentPage);
                helpersService.getAllServices().then(
                  function(data) {
                    this.industryServices = data.services.data;
                  }.bind(this)
                );
                this.notify(
                  this.$t("Toasts.Successful"),
                  this.$t("Service.DeleteServicePrompt.ToastSuccess"),
                  "success"
                );
              }.bind(this)
            )
            .catch(
              function() {
                this.notify(
                  this.$t("Toasts.Error"),
                  this.$t("Service.DeleteServicePrompt.ToastFail"),
                  "danger"
                );
              }.bind(this)
            )
            .finally(
              function() {
                this.hideLoading();
              }.bind(this)
            );
        }.bind(this),
      });
    },
    promptShow() {
      this.$tours["ServicesA"].stop();
      this.activeUpdatePrompt = true;
      this.steps[0].content = this.$t("Customer.Prompt.Content");
      this.steps[0].target = "footer .vs-button-warning";
      this.steps[0].params.placement = "auto";
      setTimeout(() => this.$tours["ServicesB"].start(), 500);
    },
    promptShowNew() {
      this.$tours["ServicesB"].stop();
      this.activeUpdatePrompt = false;
      setTimeout(() => this.$tours["ServicesA"].start(1), 500);
    },
    goToNextPage() {
      router.push({ path: "/settings/rules?istour=on" });
    },
  },
  computed: {},
  mounted() {
    this.showLoading();
    privateServiceService
      .getAll()
      .then(
        function(data) {
          this.servicesParent = data.services;
        }.bind(this)
      )
      .finally(() => {
        this.hideLoading();
      });
    privateServiceService
      .getPage(1)
      .then(
        function(data) {
          this.services = data.services.data;
          this.totalItems = data.services.total;
          this.maxItems = data.services.per_page;
          this.totalPages = data.services.last_page;
          this.$t("Service.Content").map(
            (content, index) => (this.steps[index].content = content)
          );
          this.$route.query.istour && localStorage.getItem("skipTour") != "true"
            ? this.$tours["ServicesA"].start()
            : "";
        }.bind(this)
      )
      .finally(() => {
        this.hideLoading();
      });

    helpersService.getAllServices().then(
      function(data) {
        this.industryServices = data.services.data;
      }.bind(this)
    );

    departmentService.getAll().then(
      function(data) {
        this.departments.push({
          name: this.$t("Booking.DepartmentAllOption"),
          id: -1,
        });
        this.departments = this.departments.concat(data.departments);
      }.bind(this)
    );
  },
};
</script>
